import React from "react";
import { styles } from "../styles/SlideNavigationStyles";
import { phases } from "../constants/DeliverablesPhases";
import { Text, View } from "@react-pdf/renderer";

export default function ResultsNavigationBar({
  selectIdx,
}: {
  selectIdx: number;
}) {
  return (
    <View style={styles.topNavigation}>
      {phases.map((item, index) => {
        return (
          <View key={index} style={styles.center}>
            <View
              style={
                index === selectIdx
                  ? styles.navigationBoxSelected
                  : styles.navigationBox
              }
            ></View>
            <Text style={styles.text}>{item}</Text>
          </View>
        );
      })}
    </View>
  );
}
